export default __webpack_public_path__ + "static/media/Hill.33548a9a.png";